import { t } from '@lingui/macro'
import styled, { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { openAppSettings } from '@/capacitor/utils/app-settings'

type Props = {
  onNext: () => void
}
export function CameraNotAvailable({ onNext }: Props) {
  const theme = useTheme()

  const openSettings = () => {
    openAppSettings()
  }

  return (
    <StContainer>
      <H3 noMargin>
        {t({
          id: 'questionnaire.file-upload.permission-denied.title',
          message: 'Geen toegang tot de camera',
        })}
      </H3>
      <P type='BodyMediumRegular' textAlign='center'>
        {t({
          id: 'questionnaire.file-upload.permission-denied.description',
          message:
            'Om een foto te kunnen maken, moet je toegang geven tot de camera of foto bibliotheek. Ga naar de instellingen van je telefoon om toegang te geven.',
        })}
      </P>

      <FlexColumn gap={theme.UI.SpacingPx.Space2} style={{ width: '100%' }}>
        <Button variant='Primary' onClick={openSettings}>
          {t({
            id: 'questionnaire.file-upload.permission-denied.button',
            message: 'Instellingen openen',
          })}
        </Button>

        <Button variant='Secondary' onClick={onNext}>
          {t({
            id: 'questionnaire.file-upload.permission-denied.skip',
            message: 'Overslaan',
          })}
        </Button>
      </FlexColumn>
    </StContainer>
  )
}

const StContainer = styled(FlexColumn)`
  gap: ${({ theme }) => theme.UI.SpacingPx.Space4};
  padding: ${({ theme }) => theme.UI.SpacingPx.Space4};

  justify-content: center;
  align-items: center;
`
